import { AnyAction, Reducer } from 'redux';
import { WipAction, WipActionType } from '../../actions';
import { EMPTY_WIP_STATE } from '../../constants';
import { WipState } from '../../state';
import produce from 'immer';

export const wipReducer: Reducer<WipState, AnyAction> = (
  state: WipState = EMPTY_WIP_STATE,
  action: WipAction,
) =>
  produce(state, draft => {
    switch (action.type) {
      case WipActionType.ClearPageKey: {
        draft.pageKey = null;
        return;
      }

      case WipActionType.SetPageKey: {
        draft.pageKey = action.pageKey;
        return;
      }
    }
  });
